var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
import { createElement, useEffect, useRef } from 'react';
import { usePropertyToAttribute } from '../usePropertyToAttribute/usePropertyToAttribute';
import { withRef } from '../withRef/withRef';
/**
 * Wrap custom element to be "react compatible".
 *
 * @param tagName Name of the component being wrapped.
 */
export const wrapCustomElement = tagName =>
  withRef(`CustomElement(${tagName})`, (_a, passedRef) => {
    var { children } = _a,
      properties = __rest(_a, ['children']);
    const ref = useRef(null);
    const propertyToAttribute = usePropertyToAttribute(ref);
    if (passedRef) {
      // If is a RefCallback
      if (typeof passedRef === 'function') {
        passedRef(ref.current);
      } else {
        // If is a RefObject
        if (typeof passedRef === 'object') {
          passedRef.current = ref.current;
        }
      }
    }
    useEffect(() => {
      Object.entries(properties).forEach(([property, value]) =>
        propertyToAttribute(property, value)
      );
    }, [properties, propertyToAttribute]);
    return createElement(tagName, { ref }, children);
  });
export default wrapCustomElement;
